export default ({ showPkRemoval, showGrids, permissions }) =>
  [
    { id: 'phosphorus', name: 'P', permission: 'VIEW_P_LAYER' },
    {
      id: 'phosphorus-critical',
      name: 'P Critical',
      permission: 'VIEW_P_CRITICAL_LAYER',
    },
    {
      id: 'phosphorus-delta-critical',
      name: 'P Delta to Critical',
      permission: 'VIEW_P_DELTA_CRITICAL_LAYER',
    },
    showPkRemoval && {
      id: 'phosphorus-removal',
      name: 'P Removal',
      permission: 'VIEW_P_REMOVAL_LAYER',
    },
    { id: 'potassium', name: 'K', permission: 'VIEW_K_LAYER' },
    {
      id: 'potassium-critical',
      name: 'K Critical',
      permission: 'VIEW_K_CRITICAL_LAYER',
    },
    {
      id: 'potassium-delta-critical',
      name: 'K Delta to Critical',
      permission: 'VIEW_K_DELTA_CRITICAL_LAYER',
    },
    showPkRemoval && {
      id: 'potassium-removal',
      name: 'K Removal',
      permission: 'VIEW_K_REMOVAL_LAYER',
    },
    {
      id: 'potential-productivity',
      name: 'Potential Productivity',
      permission: 'VIEW_PRODUCTIVITY_LAYER',
    },
    {
      id: 'nitrogen-loss',
      name: 'Nitrogen Loss',
      permission: 'VIEW_N_LOSS_LAYER',
    },
    { id: 'swi', name: 'SWI' },
    { id: 'slope', name: 'Slope' },
    { id: 'om', name: 'Organic Matter' },
    { id: 'cec', name: 'CEC' },
    { id: 'buffer-ph', name: 'Buffer pH' },
    { id: 'ph', name: 'pH' },
    { id: 'irrigation', name: 'Irrigation' },
    {
      id: 'boundary',
      name: 'Boundaries',
      hidden: true,
      visible: true,
      minZoom: 4,
    },
    showGrids && {
      id: 'h3-grid',
      name: 'H3 Grid',
      minZoom: 4,
      buildLayerLabel: (layer) => {
        if (!layer.meta?.resolution) return layer.name;
        return `${layer.name} (r${layer.meta.resolution})`;
      },
    },
    showGrids && { id: 'aa-grid', name: 'AA Grid', minZoom: 18 },
  ].filter((layer) => {
    if (!layer) return;

    return layer.permission ? permissions.includes(layer.permission) : true;
  });
